import { render, staticRenderFns } from "./AmountsToPay.vue?vue&type=template&id=785791fb&"
import script from "./AmountsToPay.vue?vue&type=script&lang=js&"
export * from "./AmountsToPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports